export default (theme) => ({
  switch: {
    width: 28,
    height: 28,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      cursor: "pointer",
      "& path": {
        fill: theme.palette.text[100],
      },
    },
    "&:hover": {
      color: theme.palette.primary.main,
      "& path": {
        fill: theme.palette.primary.main,
      },
    },
  },
  lang: {
    width: 140,

    "& li": {
      height: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "0 16px",
      fontSize: 16,
      fontWeight: 500,
      lineHeight: "24px",
      cursor: "pointer",
      color: theme.palette.text[100],
      whiteSpace: "nowrap",
      marginBottom: 10,
      "&:last-of-type": {
        marginBottom: 0,
      },
      "&.lang": {
        color: theme.palette.text[60],
        fontSize: 14,
      },
      "&.on": {
        background: theme.palette.grey[5],
        color: theme.palette.primary.main,
        borderRadius: 4,
      },
    },
  },
  switchlang: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text[100],
    gap: 4,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 500,
    // "&:hover": {
    //   color: theme.palette.primary.main,
    //   svg: {
    //     color: theme.palette.primary.main,
    //   },
    // },
    "& svg": {
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
  },
  g_svg_stroke: {
    "& path": {
      stroke: "currentColor",
    },
  },
  qrcode: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    "& div": {
      width: 150,
      height: 150,
      background: "#D9D9D9",
      "& img": {
        width: 150,
        height: 150,
        display: "block",
      },
    },
    "& p": {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: "21px",
      textAlign: "center",
      color: theme.palette.text[60],
    },
    "& a": {
      width: 150,
      height: 38,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: theme.palette.primary.main,
      color: theme.palette.text[5],
      borderRadius: 4,
      whiteSpace: "nowrap",
      fontSize: 12,
      "&:hover": {
        color: theme.palette.primary[20],
      },
      "&:active": {
        background: theme.palette.primary.m50,
        color: theme.palette.primary[50],
      },
    },
  },
  header_popover_btn: {
    position: "relative",
    "& .header_popover": {
      position: "absolute",

      flexDirection: "column",
      alignItems: "flex-start",
      padding: 24,

      transition: "all .3s ease-in-out",
      background: theme.palette.grey.white,
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.05)",
      borderRadius: 8,
      display: "none",
      height: 0,
    },
    // "&:hover": {
    //   "& .header_popover": {
    //     display: "flex",
    //     height: "auto",
    //   },
    // },
  },
  showPopover: {
    display: "flex !important",
    height: "auto !important",
  },
  header_popover_con: {
    display: "flex",
    flexDirection: "column",
    "& a": {
      height: 40,
      color: theme.palette.text[100],
      display: "flex",
      alignItems: "center",
      padding: "0 16px",
      fontSize: 14,
      borderRadius: 4,
      fontWeight: 500,
      "&:hover": {
        background: theme.palette.grey[5],
        color: theme.palette.primary.main,
      },
    },
  },
});
